import React from 'react';
import * as FiIcons from 'react-icons/fi';
import { FiAlertTriangle } from 'react-icons/fi';

const SafeIcon = ({ icon, name, ...props }) => {
  let IconComponent;
  try {
    // Handle both cases: when icon is a string like "FiUploadCloud" or when name is provided
    if (typeof icon === 'string' && icon.startsWith('Fi')) {
      IconComponent = FiIcons[icon];
    } else {
      IconComponent = icon || (name && FiIcons[`Fi${name}`]);
    }
  } catch (e) {
    IconComponent = null;
  }

  return IconComponent
    ? React.createElement(IconComponent, props)
    : <FiAlertTriangle {...props} />;
};

export default SafeIcon;